import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=4b3810e7&"
import script from "./PlanCard.vue?vue&type=script&lang=js&"
export * from "./PlanCard.vue?vue&type=script&lang=js&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports